import { render, staticRenderFns } from "./IconSoundWave.vue?vue&type=template&id=16ac8e53&scoped=true&"
import script from "./IconSoundWave.vue?vue&type=script&lang=js&"
export * from "./IconSoundWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac8e53",
  null
  
)

export default component.exports